import sbrBenefits from './sbr-benefits';
import Card from "../../../../components/layouts/card/card";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import './benefits-bar.scss';
import { CARD_SPACING_VARIANT } from "../../../../components/layouts/card/card.types";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";

const BenefitsBar: React.FC = () => {
    return (
        <div className={'benefit-list-bar'}>
            {sbrBenefits.map(benefit => (
                <Card key={benefit.title} spacingVariant={CARD_SPACING_VARIANT.SMAll}>
                    <div className={'benefit-item'}>
                        <img src={benefit.icon as string} alt={benefit.title} />
                        <div className={'benefit-item-content'}>
                            <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{benefit.title}</FontBody1>
                            <FontBody1 color={FONT_COLOR.PRIMARY2}>{benefit.description}</FontBody1>
                        </div>
                    </div>
                </Card>
            ))}
        </div>
    );
};

export default BenefitsBar;